import { Component, OnInit, Input } from '@angular/core';

import { EventStatusService } from "../../../services/events/eventStatus/event-status.service";
import { UpdateEventStatusService } from "../../../services/events/updateEventStatus/update-event-status.service";
import { LoginService } from "../../../services/auth/login/login.service";


declare var $: any
@Component({
  selector: 'app-event-regiser-status',
  templateUrl: './event-regiser-status.component.html',
  styleUrls: ['./event-regiser-status.component.less']
})
export class EventRegiserStatusComponent implements OnInit {
  @Input('details') details: any;

  public statusData: any = []
  public skeletonLader: Boolean = true
  public submitLoading: boolean = false

  constructor(
    private EventStatusService: EventStatusService,
    private UpdateEventStatusService: UpdateEventStatusService,
    private LoginService: LoginService
  ) { }

  ngOnInit() {
  }

  async eventStatus(data) {
    this.skeletonLader = true
    $("#eventStatus").modal("show");
    this.details = data
    await this.getStatus()
    let root = this
    setTimeout(function () {
      root.skeletonLader = false
    }, 95)
    setTimeout(function () {
      $(`.status`).selectpicker('refresh');
    }, 100)
  }


  async verifyStatus(val) {
    this.submitLoading = true
    let user_id = JSON.parse(localStorage.getItem("userDetails"))
    if (user_id == undefined || user_id == null) await this.LoginService.userLogOut()

    let data = {
      "reg_id": parseInt(this.details.event_reg_id),
      "status_id": parseInt(val.status),
      "user_id": parseInt(user_id.STAFF_ID),
      "remarks": val.remarks
    }
    let result = await this.UpdateEventStatusService.updateEventStatus(data)
    console.log(result)
    if (result.status == "success") {
      this.submitLoading = false
      $("#eventStatus").modal("hide");
    } else {
      this.submitLoading = false
    }
  }

  async getStatus() {
    let result = await this.EventStatusService.getStatus()
    this.statusData = result.data
    this.skeletonLader = false
    console.log(this.statusData)
  }


}
